import React from 'react'
import { GRAND_TOTAL_KEY,MEMBERSHIP_TYPE_KEY,USER_KEY } from "../Constant";


export const checkoutGoogleEvents = (data) => {
    let products_object = [];
    let google_analytics = {};

    let user = localStorage.getItem(USER_KEY);
    let membershipType = localStorage.getItem(MEMBERSHIP_TYPE_KEY);
    let customerId = 0;
    if (user) {
        user = JSON.parse(user);
        customerId = user.customer_id;
    }

    data.products?.map((product,index) => {        
        let total_value = product.discount_price;
        total_value = total_value.replace("$","");
        total_value = total_value.replace(/,/g, '');
        total_value = parseInt(total_value);
        let temp_products_object = {
            // Added by Anurag Chauhan ON 15-07-2025 TASK #161703 - Update product details in dataLayer
            item_brand: product?.designer_name,
            item_category: product?.pixel_details?.category || "",
            item_subcategory: product?.pixel_details?.sub_category || "",
            gender: product?.pixel_details?.gender || "",
            item_id: product.sku,
            item_name: product.title,
            currency: "USD",
            price: total_value,
            quantity : product.quantity
        }
        
        if(index === 0){
            let varient = (product?.product_items?.filter((x) => x.name === "Size")[0]?.value ||"")+"-"+(product?.product_items?.filter((x) => x.name === "Color")[0]?.value ||"") ;            
            google_analytics = {
                "id": product.product_id,
                "name": product.title,
                "price": total_value,
                "variant": varient,
                "category": "Darveys/"+product.category_name,
                "brand": product.designer_name
            }
        }

        products_object = [...products_object,temp_products_object];
        return ("");
    }); 

    window.dataLayer.push({
        ecommerce: null
    }); // Clear the previous ecommerce object.
    window.dataLayer.push({
    event: "begin_checkout_GA4",
    ecommerce: {
        'customer_id': customerId,
        'membership_type': user?.total_order > 0 ? "Existing" : membershipType == "Existing" ? "Existing" : "New", // @Task #161240 Updated membership type to use total_order count by Anurag Chauhan ON 26-06-2025
        currency: "USD",
        items: products_object,
        // Added by Anurag Chauhan ON 15-07-2025 TASK #161703 - Update product details in dataLayer and total amount of the products in the cart multiplied by the quantity
        total_cart_value: data?.products?.reduce((acc, product) => acc + parseInt(product.discount_price.replace("$", "").replace(/,/g, "")) * product.quantity, 0),
        total_cart_quantity: data?.products?.reduce((acc, product) => acc + parseInt(product.quantity), 0),
        all_sku_ids: data?.products?.map((x) => x.sku).join("|"),
        all_product_names: data?.products?.map((x) => x.title).join("|"),
        total_quantity_list: data?.products?.map((x) => x.quantity).join("|"),
        // this should be the total amount of the products in the cart multiplied by the quantity
        total_amount_list: data?.products?.map((x) => parseInt(x.discount_price.replace("$", "").replace(/,/g, "")) * x.quantity).join("|"),
        }
    });
    
}

export const GoogleProductEvents = (data) => {   
    let user = localStorage.getItem(USER_KEY);
    let membershipType = localStorage.getItem(MEMBERSHIP_TYPE_KEY);
    let customerId = 0;
    if (user) {
        user = JSON.parse(user);
        customerId = user.customer_id;
    }
    let sku = data?.product?.product_info;
    let total_value = data?.product?.discount_price || "";
    total_value = total_value.replace("$","");
    total_value = total_value.replace(/,/g, '');
    total_value = parseInt(total_value);
    
    window.dataLayer.push({
        ecommerce: null
    }); // Clear the previous ecommerce object.
    window.dataLayer.push({
        event: "view_product_page_GA4",
        ecommerce: {
            'customer_id': customerId,
            'membership_type': user?.total_order > 0 ? "Existing" : membershipType == "Existing" ? "Existing" : "New", // @Task #161240 Updated membership type to use total_order count by Anurag Chauhan ON 26-06-2025
            items: [{
                item_id: sku[0]?.value,
                item_name: data?.product?.name || "",
                page_type: "product",
                currency: "USD",
                price: total_value ,                        
                quantity : "1",
                // Added by Anurag Chauhan ON 15-07-2025 TASK #161703 - Update product details in dataLayer
                item_brand: data?.product?.designer_name,
                item_category: data?.product?.pixel_details?.category || "",
                item_subcategory: data?.product?.pixel_details?.sub_category || "",
                gender: data?.product?.pixel_details?.gender || "",
            }]
        }
    });

}

export const GooglewishlistEvents = () => {    
  }

  export const GooglePurchaseEvents = (data,gaProductsDetails) => {   
    let products_object = [];
    let user = localStorage.getItem(USER_KEY);
    let membershipType = localStorage.getItem(MEMBERSHIP_TYPE_KEY);
    let customerId = 0;
    if (user) {
        user = JSON.parse(user);
        customerId = user.customer_id;
    }
    
    let total_value = data?.order_total || "";
    total_value = total_value.replace("$","");
    total_value = total_value.replace(/,/g, '');
    total_value = parseInt(total_value);

    gaProductsDetails?.map((product) => {        
        let total_product_value = product?.price || "";
        total_product_value = total_product_value.replace("$","");
        total_product_value = total_product_value.replace(/,/g, '');
        total_product_value = parseInt(total_product_value);
        let temp_products_object = {
            item_id: product?.id || "",
            item_name: product?.name || "",
            price: total_product_value,
            quantity : product?.quantity || "",
            // Added by Anurag Chauhan ON 15-07-2025 TASK #161703 - Update product details in dataLayer
            item_brand: product?.brand || "",
            item_category: product?.pixel_details?.category || "",
            item_subcategory: product?.pixel_details?.sub_category || "",
            gender: product?.pixel_details?.gender || "",
        }
        products_object = [...products_object,temp_products_object];
        return ("");
    }); 
    
    window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    window.dataLayer.push({
    event: "purchase_GA4",
    'customer_id': customerId,
    'membership_type': user?.total_order > 0 ? "Existing" : membershipType == "Existing" ? "Existing" : "New", // @Task #161240 Updated membership type to use total_order count by Anurag Chauhan ON 26-06-2025
    ecommerce: {
      transaction_id: data?.order_number,   
      value: total_value,
      tax: 0, //hardcoded  
      shipping: 0, //hardcoded
      currency: "USD",
      items: products_object,
      // Added by Anurag Chauhan ON 15-07-2025 TASK #161703 - Update product details in dataLayer
      total_cart_value: gaProductsDetails?.reduce((acc, product) => acc + parseInt(product.price.replace("$", "").replace(/,/g, "")) * product.quantity, 0),
      total_cart_quantity: gaProductsDetails?.reduce((acc, product) => acc + parseInt(product.quantity), 0),
      all_sku_ids: gaProductsDetails?.map((x) => x.id).join("|"),
      all_product_names: gaProductsDetails?.map((x) => x.name).join("|"),
      total_quantity_list: gaProductsDetails?.map((x) => x.quantity).join("|"),
      // this should be the total amount of the products in the cart multiplied by the quantity
      total_amount_list: gaProductsDetails?.map((x) => parseInt(x.price.replace("$", "").replace(/,/g, "")) * x.quantity).join("|"),
      }
    });    
  } 
  
  export const GoogleCategoryPageEvents = (data,searchTerm) => { 
    let user = localStorage.getItem(USER_KEY);
    let membershipType = localStorage.getItem(MEMBERSHIP_TYPE_KEY);
    let customerId = 0;
    let gender = ""; // Added by Anurag Chauhan ON 15-07-2025 TASK #161703 - Update product details in dataLayer
    if (user) {
        user = JSON.parse(user);
        customerId = user.customer_id;
    }
    let category_name = "";
    if(searchTerm !== ""){
        category_name = searchTerm;
    }else{
        let breadcrumbs = data?.breadcrumb || [];
        // updated breadcrumbs to array of objects with label and link and first and last to get gender and category name by Anurag Chauhan ON 15-07-2025 TASK #161703 - Update product details in dataLayer
        category_name = (breadcrumbs.length> 0) ? breadcrumbs[breadcrumbs.length-1]?.label : "";
        gender = (breadcrumbs.length> 0) ? breadcrumbs[1]?.label : "";
    }
    window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
    window.dataLayer.push({
      event: "view_catalog_page_GA4",
      ecommerce: {
        'customer_id': customerId,
        'membership_type': user?.total_order > 0 ? "Existing" : membershipType == "Existing" ? "Existing" : "New", // @Task #161240 Updated membership type to use total_order count by Anurag Chauhan ON 26-06-2025
        items: [{
            'page_type': 'Catalog',
            'category':  category_name,
            'gender': gender // Added by Anurag Chauhan ON 15-07-2025 TASK #161703 - Update product details in dataLayer
        }]
        }
    });
  }
  export const GoogleCommonEvents = (data) => {    
    
  }

  export const GoogleAddToCartEvents = (product, cartProduct) => {
    let user = localStorage.getItem(USER_KEY);
    let membershipType = localStorage.getItem(MEMBERSHIP_TYPE_KEY);
    let customerId = 0;
    if (user) {
        user = JSON.parse(user);
        customerId = user.customer_id;
    }
    let sku = product?.product_info;
    let total_value = product?.discount_price || "";
    total_value = total_value.replace("$","");
    total_value = total_value.replace(/,/g, '');
    total_value = parseInt(total_value);        
    const product_details = product?.options[0]?.items?.find((x) => x.id === cartProduct?.value);    
    window.dataLayer.push({
        ecommerce: null
    }); // Clear the previous ecommerce object.
    window.dataLayer.push({
        event: "add_to_cart_GA4",
        ecommerce: {
            'customer_id': customerId,
            'membership_type': user?.total_order > 0 ? "Existing" : membershipType == "Existing" ? "Existing" : "New", // @Task #161240 Updated membership type to use total_order count by Anurag Chauhan ON 26-06-2025    
            currency: "USD",
            items: [{
                item_id: product_details?.sku !== "" ? product_details?.sku : sku[0]?.value,
                item_name: product?.name || "",
                currency: "USD",
                price: total_value ,                        
                quantity : "1",
                // Added by Anurag Chauhan ON 15-07-2025 TASK #161703 - Update product details in dataLayer
                item_brand: product?.designer_name,
                item_category: product?.pixel_details?.category || "",
                item_subcategory: product?.pixel_details?.sub_category || "",
                gender: product?.pixel_details?.gender || "",
            }]
        }
    });

  }

  export const GoogleCheckoutButtonEvents = (button_type) => {    
  }
// export default GoogleEvents